import { render, staticRenderFns } from "./SwitchBackup.vue?vue&type=template&id=b68d6900"
import script from "./SwitchBackup.vue?vue&type=script&lang=js"
export * from "./SwitchBackup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports